import React from "react";
import { useTranslation } from "react-i18next";
import { Chip, StatusGlyph } from "@outpave/ds";
import type { RewardRuleStatus } from "./types";
import {
  REWARD_RULE_STATUS_LABEL,
  REWARD_RULE_STATUS_TONE,
} from "utils/rewards/rewardRules";

const RewardRuleStatusChip: React.FC<{ status: RewardRuleStatus }> = ({
  status,
}) => {
  const { t } = useTranslation();
  const label = t(REWARD_RULE_STATUS_LABEL[status]);
  const tone = REWARD_RULE_STATUS_TONE[status];
  return (
    <Chip
      size="sm"
      tone={tone}
      leading={
        <StatusGlyph status={REWARD_RULE_STATUS_LABEL[status]} tone={tone} />
      }
    >
      {label}
    </Chip>
  );
};

export default RewardRuleStatusChip;
